import React, { useState } from "react";
import styles from "./styles.css";
import Banner from "./images/expired-banner.png";
import Button from "../../../shared/button";
import PropTypes from "prop-types";
import { useHistory } from "react-router";
import CloseButton from "../../../shared/icon-cross";
import { AU_DESKTOP_EVENTS } from "../../../../tracking/au.desktop-events";
import { trackDesktopCustomEventsAU } from "../../../../tracking";

const FinancingCfExpired = ({
    updatePreAppovalLoanConnect,
    fromModal = false,
    isModalopen = true,
    handleCloseModal = () => {}
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const handleEditFinanceForm = async () => {
        setIsLoading(true);
        try {
            await updatePreAppovalLoanConnect({submitted: false});
            setIsLoading(false);
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.PRE_APPROVAl_EDIT_EXPIRED);
            history.push("/financing/get-pre-approval");
        } catch (err) {
            setIsLoading(false);
            // TODO: err
        }
    };

    return (
        <React.Fragment>
            {isModalopen && <div styleName={fromModal ? "styles.wrapper styles.modalWrapper" : "styles.wrapper"}>
                {fromModal && <div styleName={"styles.closeButton"} onClick={handleCloseModal}>
                    <CloseButton type="grey" />
                </div>}
                <div styleName={"styles.outer"}>
                    {fromModal && <h1 styleName={"styles.contentSubheading"}>Your personalised loan terms have expired</h1>}
                    <img src={Banner} />
                    {!fromModal && <h2 styleName={"styles.contentHeader"}>Your loan terms have expired</h2>}
                    <p styleName={"styles.description"}>Re-apply to see your personalised weekly payments, deposit price and interest rate on every vehicle</p>
                    <span styleName={"styles.buttonWrapper"}>
                        <Button text="APPLY AGAIN" onClick={handleEditFinanceForm} isLoading={isLoading} />
                    </span>
                </div>
            </div>}
        </React.Fragment>
    );
};

FinancingCfExpired.propTypes = {
    updatePreAppovalLoanConnect: PropTypes.func,
    handleCloseModal: PropTypes.func,
    fromModal: PropTypes.bool,
    isModalopen: PropTypes.bool
};

export default FinancingCfExpired;
